import { render, staticRenderFns } from "./StockItemDetail.vue?vue&type=template&id=36cc3196"
import script from "./StockItemDetail.vue?vue&type=script&lang=js"
export * from "./StockItemDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36cc3196')) {
      api.createRecord('36cc3196', component.options)
    } else {
      api.reload('36cc3196', component.options)
    }
    module.hot.accept("./StockItemDetail.vue?vue&type=template&id=36cc3196", function () {
      api.rerender('36cc3196', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/StockItemDetail.vue"
export default component.exports